import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  mutation: gql`
    mutation changeCardPhone($cardId: ID!, $phone: String!) {
      changeCardPhone(cardId: $cardId, phone: $phone) {
        phoneChanged
      }
    }
  `,
  config: {
    options: ({ cardId, phone }) => ({
      variables: {
        cardId,
        phone,
      },
    }),
  },
  propTypes: {
    cardId: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/cards/changeCardPhone.js